import type { GuideStep } from '../types';

/**
 * Save/Load actions all live inside the same File dropdown in the topbar. We
 * point every step at the dropdown's trigger button (`topbar-file-menu`) and
 * use `includeOpenMenus` so that when the user opens it, the dropdown content
 * is also covered by the spotlight.
 */
export const SAVE_LOAD_STEPS: GuideStep[] = [
  {
    id: 'saveload-1',
    page: 'index',
    section: 'save-load',
    target: 'topbar-file-menu',
    includeOpenMenus: true,
    title: { sv: 'Spara i molnet', en: 'Save to the cloud' },
    body: {
      sv: 'Öppna File-menyn i toppraden. Där hittar du Save, Load, Export (PNG/SVG/JSON), Copy JSON och Cloud workspace. Autosave är på när du är inloggad.',
      en: 'Open the File menu in the top bar. It has Save, Load, Export (PNG/SVG/JSON), Copy JSON and Cloud workspace. Autosave runs when you are signed in.',
    },
    placement: 'bottom',
    order: 1,
  },
  {
    id: 'saveload-2',
    page: 'index',
    section: 'save-load',
    target: 'topbar-file-menu',
    includeOpenMenus: true,
    title: { sv: 'Exportera', en: 'Export' },
    body: {
      sv: 'Under "Export PNG" kan du exportera som PNG, SVG eller JSON. PNG/SVG behåller zoom och layout — JSON är portabel till andra Flow Weaver-workspaces.',
      en: 'Under "Export PNG" you can export as PNG, SVG or JSON. PNG/SVG keep the zoom and layout — JSON is portable to other Flow Weaver workspaces.',
    },
    placement: 'bottom',
    interests: ['export-share'],
    order: 2,
  },
  {
    id: 'saveload-3',
    page: 'index',
    section: 'save-load',
    target: 'topbar-file-menu',
    includeOpenMenus: true,
    title: { sv: 'Dela', en: 'Share' },
    body: {
      sv: '"Share workspace" i File-menyn skapar en länk. Du kan ge läs- eller redigeringsbehörighet per person.',
      en: '"Share workspace" in the File menu generates a link. You can grant read or edit access per person.',
    },
    placement: 'bottom',
    requiresAuth: true,
    interests: ['export-share'],
    order: 3,
  },
];
